import React from 'react';
import { Route } from 'react-router-dom';

import { TAB_ITEMS } from '../components/AccountPage/constants';

import async from '@xanadu/ui-shared/components/asyncComponent';

import GlobalBannerPortal from '@xanadu/ui-shared/components/GlobalBannerPortal';

const AsyncGeneralSettings = async(() =>
  import('../containers/AccountPage/GeneralSettings').then(module => module.default)
);
const AsyncResponsibleGambling = async(() =>
  import('../containers/AccountPage/ResponsibleGambling').then(module => module.default)
);
const AsyncIntegrations = async(() =>
  import('../containers/AccountPage/Integrations').then(module => module.default)
);

const AsyncAccountVerification = async(() =>
  import('../containers/AccountPage/AccountVerification').then(module => module.default)
);

const AsyncAccountPage = async(() =>
  import('../components/AccountPage').then(module => module.default)
);

const components = {
  'general-settings': AsyncGeneralSettings,
  'safer-gambling': AsyncResponsibleGambling,
  verification: AsyncAccountVerification,
  integrations: AsyncIntegrations
};

export default function () {
  return (
    <React.Fragment>
      <GlobalBannerPortal withTabs />
      <AsyncAccountPage tabs={TAB_ITEMS}>
        {TAB_ITEMS
          .filter(tab => components[tab.key])
          .map(tab => (
            <Route
              key={tab.key}
              path={tab.href}
              component={components[tab.key]}
            />
          ))}
      </AsyncAccountPage>
    </React.Fragment>
  );
}
